export default __webpack_public_path__ + "static/media/Biodiesel.849bb3e8.pdf";